export const ERROR_NAME = 'LngLatMapError'

export class LngLatMapError extends Error {
  constructor(latLng, zipCodes) {
    super(
      `Invalid Center LatLng in map due to invalid/unsupported postal code(s). Lat:  ${latLng.lat}, Lng:  ${latLng.lng}`
    )
    this.name = ERROR_NAME
    this.latLng = latLng
    this.zipCodes = zipCodes
  }
}

export default LngLatMapError
